import { getSessionStorage } from '@trinity/chat-components/lib/storage';

const SIDE_PANEL_OPEN_STATE_KEY = 'trinity:chat:side-panel-open-state:v1';

export type SidePanelOpenState = 'open' | 'closed';

// Utility functions for managing the open/closed state of the side panel in session storage
// to override the default state once the application is loaded.
function isSidePanelOpenState(value: string | null): value is SidePanelOpenState {
  return value === 'open' || value === 'closed';
}

export function readSidePanelOpenState(): SidePanelOpenState | null {
  try {
    const value = getSessionStorage().getItem(SIDE_PANEL_OPEN_STATE_KEY);
    return isSidePanelOpenState(value) ? value : null;
  } catch {
    return null;
  }
}

export function writeSidePanelOpenState(value: SidePanelOpenState): void {
  try {
    getSessionStorage().setItem(SIDE_PANEL_OPEN_STATE_KEY, value);
  } catch {
    // Swallow storage failures; the panel should still function without persistence.
  }
}

export function clearSidePanelOpenState(): void {
  try {
    getSessionStorage().removeItem(SIDE_PANEL_OPEN_STATE_KEY);
  } catch {
    // Swallow storage failures; the panel should still function without persistence.
  }
}